<template>
  <div class="login-register">
    <div class="form-ipt">
      <div class="form-title">注 册</div>
      <div class="form-cont">
        <div class="form-item" style="margin-bottom: 20px;">
          <el-input class="left-ipt" v-model="username" placeholder="请输入昵称"></el-input>
        </div>
        <el-input placeholder="请输入手机号" v-model="registerPhoneNum">
<!--          <el-select v-model="quSelect" slot="prepend" placeholder="请选择区号">-->
<!--            <el-option v-for="(item, index) in quSelectList" :key="index" :label="item.label" :value="item.value"></el-option>-->
<!--          </el-select>-->
        </el-input>
          <div class="form-item">
              <el-input class="left-ipt" v-model="registerImgCode" placeholder="请输入验证码"></el-input>
              <img class="right-btn" :src="registerCheckImg" alt="" v-on:click="check_code">
          </div>
        <div class="form-item">
          <el-input class="left-ipt" v-model="registerYzm" placeholder="请输入6位短信验证码"></el-input>
            <el-button
                    class="right-btn"
                    :type="time === 0 ? 'primary' : 'info'"
                    :disabled="time === 0 ? false : true"
                    @click="setTime"
            >
                {{time === 0 ? '发送验证码' : time + '秒后重发'}}
            </el-button>
        </div>
        <div class="agree">
          <el-checkbox v-model="xieyi">我已阅读并接受</el-checkbox>
          <span class="xieyi">《快速动画网用户使用协议》</span>
        </div>
        <div class="login-btn">
          <el-button class="btn" size="medium"  @click="login" :loading="loading">注册</el-button>
        </div>
        <div class="no-pass">
          <router-link to="/login">已有账号，直接登录></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
    import axios from 'axios';
    import vue from 'vue';
    vue.prototype.$axios = axios;
    import qs from 'qs';
    vue.prototype.qs = qs;
    import VueCookies from 'vue-cookies'
    vue.use(VueCookies);
export default {
  components: {

  },
  data () {
    return {
      loading:false,
      quSelect: '中国 +86',
      quSelectList: [
        {
          label: '中国 +86',
          value: 1
        },
        {
          label: '中国香港 +852',
          value: 2
        },
        {
          label: '中国澳门 +853',
          value: 3
        },
        {
          label: '中国台湾 +886',
          value: 4
        },
        {
          label: '美国 +1',
          value: 5
        },
        {
          label: '日本 +81',
          value: 6
        },
        {
          label: '韩国 +82',
          value: 7
        }
      ],
        username:"",
        registerPhoneNum: '',
        registerImgCode: '',
        registerCheckImg: '',
        registerYzm: '',
        time: 0,
        fromUrl:"",
        fromQuery:"",
        xieyi: true,
    }
  },
    created:function(){
        this.check_code();
        if(window.location.href.indexOf("callback")!=-1){
            let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
            this.fromUrl=decodeURIComponent(url);
        }
    },

    methods: {
        // 倒计时
        setTime () {
            let _this=this;
            let url='/api/checkcode?time='+ new Date().getMilliseconds();
            let postData = {
                'mobile':this.registerPhoneNum,
                'captchaValue':this.registerImgCode
            }
            if(!this.registerPhoneNum){
                _this.$message({
                    message: '手机号码不能为空',
                    type: 'warning'
                });
                return false;
            }else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (!reg.test(this.registerPhoneNum)) {
                    _this.$message({
                        message: '手机号码格式有误',
                        type: 'warning'
                    });
                    return false;
                }else{
                    this.$axios.post(url, qs.stringify(postData)).then(function(result){
                        console.log(result.data);
                        if(result.data==1){
                            _this.$message({
                                message: '图形验证码不能为空',
                                type: 'warning'
                            });
                            return false;
                        }
                        if(result.data==2){
                            _this.$message({
                                message: '图形验证码填写错误',
                                type: 'warning'
                            });
                            return false;
                        }
                        if(result.data==-1){
                            _this.time = 60
                            _this.interval = setInterval(() => {
                                _this.time = _this.time - 1
                                if(_this.time === 0) {
                                    clearInterval(_this.interval)
                                }
                            }, 1000)
                        }
                    })
                }
            }


        },

        check_code:function () {
            let _this=this;
            let time= new Date().getMilliseconds();
            let url='/api/checkcode?time='+time;
            this.$axios.get(url,{responseType: 'arraybuffer'}).then(function(result){
                let img_url='data:image/png;base64,' + btoa(new Uint8Array(result.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                _this.registerCheckImg=img_url;
            })
        },
        login:function () {
            let domain = document.domain;
            console.log(domain)
            let _this=this;
            _this.loading=true;
            let url='/api/register?time='+new Date().getMilliseconds();
            let fast_login_url='http://cas.21teacher.com/smsCodeLoginCheck?time='+new Date().getMilliseconds();
            let postData2 = {
                'phonenum':this.registerPhoneNum,
                'smsCode':this.registerYzm,
            }
            let postData = {
                'mobile':this.registerPhoneNum,
                'captchaValue':this.registerYzm,
                "name":this.username,
            }
            if(!this.xieyi){
                _this.$message({
                    message: '请先阅读并接受用户协议',
                    type: 'warning'
                });
                _this.loading=false;
                return false;
            }else if(!this.username){
                _this.$message({
                    message: '昵称不能为空',
                    type: 'warning'
                });
                _this.loading=false;
                return false;
            }else if(!this.registerPhoneNum){
                _this.$message({
                    message: '手机号码不能为空',
                    type: 'warning'
                });
                _this.loading=false;
                return false;
            }else if(!this.registerYzm){
                _this.$message({
                    message: '手机验证码不能为空',
                    type: 'warning'
                });
                _this.loading=false;
                return false;
            }else{
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (!reg.test(this.registerPhoneNum)) {
                    _this.$message({
                        message: '手机号码格式有误',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else{
                    this.$axios.post(url, qs.stringify(postData)).then(function(result1){
                        if(result1.data.code==1){
                            _this.$axios.post(fast_login_url, qs.stringify(postData2)).then(function(result){
                                console.log(result.data.token)
                                if(result.data.code=="10"){
                                    let sso_sessionid =result.data.token;
                                    let user_id=result.data.userModel.id;
                                    let user_name=result.data.userModel.userName;
                                    console.log(sso_sessionid)
                                    let checkurl='/api/checkLogin?sso_sessionid='+sso_sessionid+'&time='+ new Date().getMilliseconds();
                                    _this.$axios.get(checkurl).then(function(result2){
                                        if(result2.data.isLogin&&result2.data.casFastUserModel!=null){
                                            _this.$cookies.set("userId",user_id,0,"/",'.renrendonghua.com');
                                            _this.$cookies.set("user_id",user_id,60 * 60,"/",process.env.VUE_APP_DOMAIN);
                                            _this.$cookies.set("user_name",user_name,60 * 60,"/",process.env.VUE_APP_DOMAIN);
                                            window.location.href ="http://www.renrendonghua.com/selecttype";
                                        }else{
                                            _this.$message({
                                                message: '登录失败',
                                                type: 'warning'
                                            });
                                        }
                                        _this.loading=false;
                                    })
                                }else{
                                    _this.$message({
                                        message: '登录失败',
                                        type: 'warning'
                                    });
                                    _this.loading=false;
                                }

                            })
                        }else{
                            console.log(result1.data)
                            _this.$message({
                                message: result1.data.message,
                                type: 'warning'
                            });
                            _this.loading=false;
                            return false;
                        }

                    })
                }

            }
        },

    },
    // beforeRouteEnter(to, from, next) {
    //     next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
    //         console.log(to)
    //         console.log(from)
    //         console.log(from.query);
    //         console.log(document.referrer)
    //         // if(document.referrer!=''&&document.referrer.indexOf("http://www")==-1){
    //         // if(window.location.href.indexOf("http")!= -1){
    //         //   vm.fromUrl=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
    //         // vm.fromUrl=document.referrer;
    //         // }else{
    //         //   vm.fromUrl=from.path;
    //         //   vm.fromQuery=from.query;
    //         // }
    //
    //     })
    // },

    beforeDestroy () {
        clearInterval(this.interval)
    }
}
</script>

<style scoped lang="less">
@import "../../assets/less/login.less";
</style>
